import React from "react";

export default function SpinnerOverlay() {
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );
}